<!-- <nav class="navbar navbar-expand-lg navbar-light bg-light mb-3 align-items-center"> -->
<nav class="navbar navbar-expand-lg navbar-light bg-light align-items-center navbar-green custom-header">
    <div class="container">
        <!-- <button [class.disabled]="!(hasTenantId())" class="navbar-toggler mr-2" type="button"  #toggleButton
            (click)="toggleCollapsed()">
            <span class="navbar-toggler-icon"></span>
        </button> -->
        <a class="d-block d-lg-none mb-0 color-white" (click)="back()" *ngIf="showbackbutton">
            <h6 class="mb-0"><span class="fa-fw select-all fas"></span></h6>
        </a>
        <a class="" class="navbar-brand d-none d-lg-block mb-0" routerLink="credit-union-list"
            routerLinkActive="active">
            <img src="assets/images/wakandi-white.png" alt="" width="150"></a>
        <a class="" *ngIf="!showbackbutton && isMobile" class="navbar-brand d-block d-lg-none mb-0">
            <img src="assets/images/wakandi-white.png" alt="" width="150"></a>
       
        <a class="" *ngIf="!showbackbutton && !isMobile" class="navbar-brand d-block d-lg-none mb-0"
            routerLink="credit-union-list" routerLinkActive="active">
            <img src="assets/images/wakandi-white.png" alt="" width="150"></a>
        <h6 *ngIf="showbackbutton && showPageName != ''" class="d-block d-lg-none mb-0 font-20">{{showPageName |
            localize}}</h6>
        <h6 *ngIf="showbackbutton && showPageName == ''" class="d-block d-lg-none mb-0 font-20">
            {{sharedDataService._selectedModuleName | localize}}</h6>
        <!-- <a href="#" class="nav-item nav-link notification d-lg-none ml-auto mr-2">
            <i class="fas fa-bell"></i>
        </a> -->
        <!-- <app-notification class="d-block d-lg-none" ></app-notification> -->

        <!-- <app-notification class="ml-auto mr-2 d-lg-none"></app-notification>   -->
        <!-- data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" -->


        <div id="navbarSupportedContent" class="navbar-collapse-custom" #leftmenu
            [ngClass]="{'collapse-custom ': collapsed}">

            <div class="left-menu-custom" [ngClass]="{'draweropen': draweropen}">

                <div class="navbar-nav m-lg-auto ">
                    <ul class="d-flex flex-column flex-lg-row mt-lg-0">
                        <li>
                            <a (click)="toggleCollapsed()" class="nav-item nav-link" routerLink="/credit-union-list"
                                routerLinkActive="active"> <span class="icon fa-fw select-all fas"></span>
                                {{"YourGroups" | localize }}
                            </a>
                        </li>
                        <li>
                            <a (click)="toggleCollapsed()" class="nav-item nav-link" routerLink="/profile"
                                routerLinkActive="active"> <span class="icon fa-fw select-all fas"></span>
                                {{"Profile" | localize }}
                                <!-- Profile -->
                            </a>
                        </li>

                        <li>
                            <a (click)="toggleCollapsed()" class="nav-item nav-link" routerLink="/more"
                                routerLinkActive="active"><span class="icon fa-fw select-all fas"></span>
                                {{"More" | localize }}
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="navbar-nav">
                    <ul class="d-flex mt-lg-0 align-items-lg-center flex-column flex-lg-row ">
                        <li class="px-lg-2 mb-2">
                            <a title="" class="nav-item nav-link" (click)="logout()">
                                <span class="icon">
                                    <img class="pr-2 pl-1" src="assets/images/logout.svg" alt="" width="25">
                                </span>
                                <span class="d-lg-none">
                                    {{"Logout" | localize}}
                                </span>
                            </a>
                        </li>
                        <li class="d-none d-lg-block px-lg-2">
                            <!-- <a href="#" class="nav-item nav-link notification"><i class="fas fa-bell"></i></a> -->
                            <app-notification></app-notification>
                        </li>
                    </ul>
                </div>

            </div>

        </div>
    </div>
</nav>